import './skeleton.scss';

import { JSXElement, mergeProps, Show } from 'solid-js';
import { twMerge } from 'tailwind-merge';

type SkeletonProps = {
  isLoading: boolean;
  children: JSXElement;
  class?: string;
};

export default function Skeleton(props: SkeletonProps): JSXElement {
  const merged = mergeProps(
    {
      isLoading: false,
      class: ''
    },
    props
  );
  return (
    <Show
      when={merged.isLoading}
      fallback={merged.children}
    >
      <div class={twMerge(`skeleton skeleton-text w-full my-2`, merged.class)}>
        &nbsp;
      </div>
    </Show>
  );
}
